import React from 'react';
import '../assets/styles/LegalPages.css';

const PrivacyPolicy = ({ onBack }) => {
    return (
        <div className="legal-page">
            <div className="legal-content">
                <h1>Privacy Policy</h1>
                <p className="last-updated">Last updated: January 16, 2026</p>

                <section>
                    <h2>Introduction</h2>
                    <p>
                        DadBucks ("we," "our," or "us") is committed to protecting the privacy of our users,
                        especially children. This Privacy Policy explains how we collect, use, and safeguard
                        information when you use our mobile application and website.
                    </p>
                </section>

                <section>
                    <h2>Information We Collect</h2>
                    <h3>Account Information</h3>
                    <ul>
                        <li>Parent email address (for account recovery)</li>
                        <li>Usernames and display names</li>
                        <li>Household name</li>
                    </ul>

                    <h3>Usage Data</h3>
                    <ul>
                        <li>Chores created and completed</li>
                        <li>Goals set and achieved</li>
                        <li>DadBucks earned and spent</li>
                        <li>App usage analytics (anonymized)</li>
                    </ul>

                    <h3>What We Do NOT Collect</h3>
                    <ul>
                        <li>Real financial information or bank accounts</li>
                        <li>Location data</li>
                        <li>Photos (unless optionally uploaded for chore evidence)</li>
                        <li>Contact lists or social media data</li>
                    </ul>
                </section>

                <section>
                    <h2>Children's Privacy (COPPA Compliance)</h2>
                    <p>
                        DadBucks is designed for family use. Children under 13 may use the app
                        only under parental supervision:
                    </p>
                    <ul>
                        <li>Parents create and manage child accounts</li>
                        <li>Children cannot share personal information publicly</li>
                        <li>No direct marketing to children</li>
                        <li>Parents can request deletion of child data at any time</li>
                    </ul>
                </section>

                <section>
                    <h2>How We Use Your Information</h2>
                    <ul>
                        <li>To provide and improve the DadBucks service</li>
                        <li>To send important account notifications</li>
                        <li>To track progress and achievements within your household</li>
                        <li>To provide customer support</li>
                    </ul>
                </section>

                <section>
                    <h2>Data Sharing</h2>
                    <p>We do NOT sell your data. We may share data only:</p>
                    <ul>
                        <li>With service providers who help operate our platform (e.g., hosting)</li>
                        <li>If required by law or to protect safety</li>
                        <li>With your explicit consent</li>
                    </ul>
                </section>

                <section>
                    <h2>Data Security</h2>
                    <p>
                        We implement industry-standard security measures including:
                    </p>
                    <ul>
                        <li>Encrypted data transmission (HTTPS/TLS)</li>
                        <li>Secure password hashing</li>
                        <li>Regular security audits</li>
                    </ul>
                </section>

                <section>
                    <h2>Your Rights</h2>
                    <p>You have the right to:</p>
                    <ul>
                        <li>Access your personal data</li>
                        <li>Correct inaccurate data</li>
                        <li>Request deletion of your account and data</li>
                        <li>Export your data</li>
                    </ul>
                    <p>
                        To exercise these rights, contact us at <a href="mailto:privacy@mydadbucks.com">privacy@mydadbucks.com</a>
                    </p>
                </section>

                <section>
                    <h2>Third-Party Services</h2>
                    <p>Our app may use the following third-party services:</p>
                    <ul>
                        <li><strong>Google AdMob</strong> - For displaying ads (parents can opt-out)</li>
                        <li><strong>Amazon Associates</strong> - For product recommendations in the Smart Store</li>
                        <li><strong>Expo/React Native</strong> - For app delivery and updates</li>
                    </ul>
                </section>

                <section>
                    <h2>Changes to This Policy</h2>
                    <p>
                        We may update this Privacy Policy from time to time. We will notify you of
                        any material changes via email or in-app notification.
                    </p>
                </section>

                <section>
                    <h2>Contact Us</h2>
                    <p>
                        If you have questions about this Privacy Policy or our data practices, please contact:
                    </p>
                    <p>
                        Email: <a href="mailto:privacy@mydadbucks.com">privacy@mydadbucks.com</a><br />
                        Website: <a href="https://mydadbucks.com">mydadbucks.com</a>
                    </p>
                </section>

                <div className="back-link">
                    <button onClick={onBack} className="back-link-btn">← Back to Home</button>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
